<div class="user-wrapper">
  <div class="hero card-glass mb-3">
    <div class="crumb">
      <a routerLink="/utilisateur/statistiques" class="crumb-link"><i class="bi bi-arrow-left"></i> Retour aux statistiques</a>
      <span class="crumb-current">Mes Retraits</span>
    </div>
    <div class="hero-flex">
      <div>
        <p class="eyebrow">Spay · Historique</p>
        <h1>Retraits effectués</h1>
        <p class="lead">Consultez les retraits, montants et frais associés.</p>
      </div>
    </div>
  </div>

  <div class="card-glass p-3 mb-3">
    <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2">
      <h4 class="mb-0">Historique</h4>
      <div class="d-flex align-items-center gap-2 w-100 w-sm-auto">
        <label class="mb-0" for="monthSelectRetraitsPerso">Mois</label>
        <select id="monthSelectRetraitsPerso"
          class="form-select form-select-sm bg-dark text-light border-secondary w-100 w-sm-auto"
          [(ngModel)]="selectedMonth" (change)="applyMonthFilter(selectedMonth)">
          <option *ngFor="let m of monthOptions" [value]="m.value">{{ m.label | titlecase }}</option>
        </select>
      </div>
    </div>
    <!--<p class="text-muted small mb-0">Affichage limité au mois en cours. Sélectionnez un mois antérieur pour consulter
      les retraits déjà chargés.</p>-->
  </div>

  <div class="row g-3">
    <div class="col-sm-6 col-lg-4" *ngFor="let r of retraitlist">
      <div class="card card-glass h-100">
        <div class="card-header border-0 text-white text-center font-weight-bolder">
          {{r.date | date:"dd/MM/yyyy H:mm:ss"}}
        </div>
        <div class="card-body">
          <div class="metric-row"><span>Lieu</span><strong>{{r.boutique}}</strong></div>
          <div class="metric-row"><span>Montant retrait</span><strong>{{r.amount | currency:r.sigleMonnaie}}</strong>
          </div>
          <div class="metric-row"><span>Frais</span><strong>{{r.retenu | currency:r.sigleMonnaie}}</strong></div>
          <div class="metric-row"><span>Solde avant</span><strong>{{a.soldeAvant | currency:a.sigleMonnaie}}</strong>
          </div>
          <div class="metric-row"><span>Solde apres</span><strong>{{a.soldeApres | currency:a.sigleMonnaie}}</strong>
          </div>
        </div>

      </div>
    </div>
    <div class="col-12" *ngIf="!retraitlist || retraitlist.length === 0">
      <div class="card card-glass p-3 text-center text-muted">Aucun retrait enregistré.</div>
    </div>
  </div>
</div>
